import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../../../styles/helpers';
import { ITheme } from '../../../../styles/theme';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      padding: [20, SpacingsValues.s24],

      [mediaQuery(breakpoints.tablet)]: {
        padding: [16, 20],
      },
    },
    container: {
      gap: SpacingsValues.s24,

      [mediaQuery(breakpoints.mobile)]: {
        alignItems: 'flex-start',
      },
    },
    selected: {
      borderRadius: SpacingsValues.s8,
      boxShadow: '0px 4px 16px var(--x-shadow-card)',

      '& $index': {
        backgroundColor: 'var(--x-bg-15)',
      },

      '& $title': {
        color: 'var(--x-accent-2-1)',
      },
    },
    index: {
      borderRadius: '50%',
      boxShadow: '0px 1px 4px var(--x-shadow-card)',
      color: 'var(--x-accent-2-1)',
      backgroundColor: '#fff',
      width: 56,
      height: 56,
      minWidth: 56,
      lineHeight: '56px',
      textAlign: 'center',
    },

    title: {
      color: 'var(--x-black)',
      fontWeight: 600,
    },

    description: {
      color: '#666',
      fontWeight: 500,
    },
    icon: {
      marginRight: 2,
      fill: 'var(--black)',
      minWidth: 24,
      minHeight: 24,
    },
  }),
  { name: 'InteractiveStep' },
);
